import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment.development";
@Injectable({
    providedIn:'root'
})
export class MetaService {
    constructor (private http: HttpClient){

    }

    getmeta(): Observable<any>{
        return this.http.get(`${environment.backent_ApiUrl}/metadata`)
    }
}